module.exports = __webpack_public_path__ + "static/img/profile-icon08.c7d7070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon08.png
// module id = 2956
// module chunks = 1